export default [
	{
		label: '(GMT-12:00) International Date Line West',
		value: 'Etc/GMT+12'
	},
	{
		label: '(GMT-11:00) Midway Island, Samoa',
		value: 'Pacific/Midway'
	},
	{
		label: '(GMT-10:00) Hawaii',
		value: 'Pacific/Honolulu'
	},
	{
		label: '(GMT-09:00) Alaska',
		value: 'America/Juneau'
	},
	{
		label: '(GMT-07:00) Mountain Time (US and Canada)',
		value: 'America/Boise'
	},
	{
		label: '(GMT-07:00) Chihuahua, La Paz, Mazatlan',
		value: 'America/Chihuahua'
	},
	{
		label: '(GMT-07:00) Pacific Time (US and Canada); Tijuana',
		value: 'America/Dawson'
	},
	{
		label: '(GMT-07:00) Arizona',
		value: 'America/Phoenix'
	},
	{
		label: '(GMT-06:00) Central America',
		value: 'America/Belize'
	},
	{
		label: '(GMT-06:00) Central Time (US and Canada)',
		value: 'America/Chicago'
	},
	{
		label: '(GMT-06:00) Guadalajara, Mexico City, Monterrey',
		value: 'America/Mexico_City'
	},
	{
		label: '(GMT-06:00) Saskatchewan',
		value: 'America/Regina'
	},
	{
		label: '(GMT-05:00) Bogota, Lima, Quito',
		value: 'America/Bogota'
	},
	{
		label: '(GMT-05:00) Eastern Time (US and Canada)',
		value: 'America/Detroit'
	},
	{
		label: '(GMT-05:00) Indiana (East)',
		value: 'America/Indiana/Indianapolis'
	},
	{
		label: '(GMT-04:00) Caracas, La Paz',
		value: 'America/Caracas'
	},
	{
		label: '(GMT-04:00) Atlantic Time (Canada)',
		value: 'America/Glace_Bay'
	},
	{
		label: '(GMT-03:30) Newfoundland and Labrador',
		value: 'America/St_Johns'
	},
	{
		label: '(GMT-03:00) Buenos Aires, Georgetown',
		value: 'America/Argentina/Buenos_Aires'
	},
	{
		label: '(GMT-03:00) Greenland',
		value: 'America/Godthab'
	},
	{
		label: '(GMT-03:00) Santiago',
		value: 'America/Santiago'
	},
	{
		label: '(GMT-03:00) Brasilia',
		value: 'America/Sao_Paulo'
	},
	{
		label: '(GMT-02:00) Mid-Atlantic',
		value: 'Etc/GMT+2'
	},
	{
		label: '(GMT-01:00) Azores',
		value: 'Atlantic/Azores'
	},
	{
		label: '(GMT-01:00) Cape Verde Islands',
		value: 'Atlantic/Cape_Verde'
	},
	{
		label: '(GMT) Canary Islands',
		value: 'Atlantic/Canary'
	},
	{
		label: '(GMT) Dublin, Edinburgh, Lisbon, London',
		value: 'GMT'
	},
	{
		label: '(GMT+01:00) West Central Africa',
		value: 'Africa/Algiers'
	},
	{
		label: '(GMT+01:00) Casablanca, Monrovia',
		value: 'Africa/Casablanca'
	},
	{
		label: '(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna',
		value: 'Europe/Amsterdam'
	},
	{
		label: '(GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague',
		value: 'Europe/Belgrade'
	},
	{
		label: '(GMT+01:00) Brussels, Copenhagen, Madrid, Paris',
		value: 'Europe/Brussels'
	},
	{
		label: '(GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb',
		value: 'Europe/Sarajevo'
	},
	{
		label: '(GMT+02:00) Cairo',
		value: 'Africa/Cairo'
	},
	{
		label: '(GMT+02:00) Harare, Pretoria',
		value: 'Africa/Harare'
	},
	{
		label: '(GMT+02:00) Jerusalem',
		value: 'Asia/Jerusalem'
	},
	{
		label: '(GMT+02:00) Athens, Istanbul, Minsk',
		value: 'Europe/Athens'
	},
	{
		label: '(GMT+02:00) Bucharest',
		value: 'Europe/Bucharest'
	},
	{
		label: '(GMT+02:00) Helsinki, Kiev, Riga, Sofia, Tallinn, Vilnius',
		value: 'Europe/Helsinki'
	},
	{
		label: '(GMT+03:00) Nairobi',
		value: 'Africa/Nairobi'
	},
	{
		label: '(GMT+03:00) Baghdad',
		value: 'Asia/Baghdad'
	},
	{
		label: '(GMT+03:00) Kuwait, Riyadh',
		value: 'Asia/Kuwait'
	},
	{
		label: '(GMT+03:00) Moscow, St. Petersburg, Volgograd',
		value: 'Europe/Moscow'
	},
	{
		label: '(GMT+03:30) Tehran',
		value: 'Asia/Tehran'
	},
	{
		label: '(GMT+04:00) Baku, Tbilisi, Yerevan',
		value: 'Asia/Baku'
	},
	{
		label: '(GMT+04:00) Abu Dhabi, Muscat',
		value: 'Asia/Dubai'
	},
	{
		label: '(GMT+04:30) Kabul',
		value: 'Asia/Kabul'
	},
	{
		label: '(GMT+05:00) Islamabad, Karachi, Tashkent',
		value: 'Asia/Karachi'
	},
	{
		label: '(GMT+05:00) Ekaterinburg',
		value: 'Asia/Yekaterinburg'
	},
	{
		label: '(GMT+05:30) Sri Jayawardenepura',
		value: 'Asia/Colombo'
	},
	{
		label: '(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi',
		value: 'Asia/Kolkata'
	},
	{
		label: '(GMT+05:45) Kathmandu',
		value: 'Asia/Kathmandu'
	},
	{
		label: '(GMT+06:00) Almaty, Novosibirsk',
		value: 'Asia/Almaty'
	},
	{
		label: '(GMT+06:00) Astana, Dhaka',
		value: 'Asia/Dhaka'
	},
	{
		label: '(GMT+06:30) Yangon Rangoon',
		value: 'Asia/Rangoon'
	},
	{
		label: '(GMT+07:00) Bangkok, Hanoi, Jakarta',
		value: 'Asia/Bangkok'
	},
	{
		label: '(GMT+07:00) Krasnoyarsk',
		value: 'Asia/Krasnoyarsk'
	},
	{
		label: '(GMT+08:00) Irkutsk, Ulaanbaatar',
		value: 'Asia/Irkutsk'
	},
	{
		label: '(GMT+08:00) Kuala Lumpur, Singapore',
		value: 'Asia/Kuala_Lumpur'
	},
	{
		label: '(GMT+08:00) Beijing, Chongqing, Hong Kong SAR, Urumqi',
		value: 'Asia/Shanghai'
	},
	{
		label: '(GMT+08:00) Taipei',
		value: 'Asia/Taipei'
	},
	{
		label: '(GMT+08:00) Perth',
		value: 'Australia/Perth'
	},
	{
		label: '(GMT+09:00) Seoul',
		value: 'Asia/Seoul'
	},
	{
		label: '(GMT+09:00) Osaka, Sapporo, Tokyo',
		value: 'Asia/Tokyo'
	},
	{
		label: '(GMT+09:00) Yakutsk',
		value: 'Asia/Yakutsk'
	},
	{
		label: '(GMT+09:30) Darwin',
		value: 'Australia/Darwin'
	},
	{
		label: '(GMT+10:00) Vladivostok',
		value: 'Asia/Vladivostok'
	},
	{
		label: '(GMT+10:00) Brisbane',
		value: 'Australia/Brisbane'
	},
	{
		label: '(GMT+10:00) Guam, Port Moresby',
		value: 'Pacific/Guam'
	},
	{
		label: '(GMT+10:30) Adelaide',
		value: 'Australia/Adelaide'
	},
	{
		label: '(GMT+11:00) Magadan, Solomon Islands, New Caledonia',
		value: 'Asia/Magadan'
	},
	{
		label: '(GMT+11:00) Hobart',
		value: 'Australia/Hobart'
	},
	{
		label: '(GMT+11:00) Canberra, Melbourne, Sydney',
		value: 'Australia/Sydney'
	},
	{
		label: '(GMT+12:00) Fiji Islands, Kamchatka, Marshall Islands',
		value: 'Pacific/Fiji'
	},
	{
		label: '(GMT+13:00) Auckland, Wellington',
		value: 'Pacific/Auckland'
	},
	{
		label: "(GMT+13:00) Nuku'alofa",
		value: 'Pacific/Tongatapu'
	}
];
